module.exports = __webpack_public_path__ + "img/crowd3.38583266.jpg";